import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { InputTypes } from "../../../../constants/enums";

const StyledWrapper = styled.div`
  display: flex;
  gap: 60px;
  .checkbox-label {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    position: relative;
    cursor: pointer;
  }

  .checkbox-input {
    margin-right: 10px;
    cursor: pointer;
    transform: scale(1.5);
    accent-color: var(--main-color);
    border-radius: var(--border-radius);
    appearance: none;
    -webkit-appearance: none;
    position: relative;
    width: ${({ isCheckbox }) => (isCheckbox ? "16px" : "24px")};
    height: 14px;
    border: none !important;
  }

  .checkbox-input:checked::after {
    content: "✓";
    color: white;
    font-size: 13px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--main-color);
    width: 15px;
    height: 15px;
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: ${({ isCheckbox }) => (!isCheckbox ? "50%;" : "3px")};
  }

  .checkbox-input::after {
    content: "";
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    width: 15px;
    height: 15px;
    border: 1px solid var(--main-color);
    border-radius: ${({ isCheckbox }) => (!isCheckbox ? "50%;" : "3px")};
  }

  .option-text {
    font-weight: 400;
    font-size: 1rem;
    color: #161616;

    .custom-text {
      color: #004496;
      font-weight: 600;
      font-size: 1rem;
    }

    .subtext {
      font-size: 0.9rem;
      color: #666;
    }
  }
`;

const RadioInput = ({ fieldItem, value, onChange, errorMessage }) => {
  const { name, type, id, options } = fieldItem;
  const { t } = useTranslation();

  const isCheckbox = type === InputTypes?.checkbox;

  const handleChange = (optionValue) => {
    if (isCheckbox) {
      const newValue = value?.includes(optionValue)
        ? value.filter((v) => v !== optionValue)
        : [...(value || []), optionValue];
      onChange(newValue);
    } else {
      onChange(optionValue);
    }
  };

  return (
    <StyledWrapper
      className="checkbox-row"
      isCheckbox={isCheckbox}
      errorMessage={errorMessage}
    >
      {options?.map((option, index) => (
        <label key={index} className="checkbox-label">
          <input
            id={`${id}-${index}`}
            type={type}
            name={name}
            value={option.value}
            checked={
              isCheckbox
                ? value?.includes(option.value)
                : value === option.value
            }
            onChange={() => handleChange(option.value)}
            className="checkbox-input"
          />
          <span className="option-text">{t(option.label)}</span>
        </label>
      ))}
    </StyledWrapper>
  );
};

export default RadioInput;
